import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

$(function () {
    if (window.location.hash) {
        let target = $(window.location.hash);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 300);
        }
    }

    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        let hash = $(this).attr('href');
        let target = $(hash);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 500);
        }
    })

    $(".owl-carousel").each(function () {
        if ($(this).children().length > 1) {
            $(this).owlCarousel({
                items: 1,
                loop: true,
                autoplay: $(this).data('autoplay'),
                autoplayTimeout: 10000,
                autoplayHoverPause: true,
                dots: true
            });
        } else {
            $(this).owlCarousel({
                items: 1,
                autoplay: false,
                dots: false,
                mouseDrag: false
            });
        }
    });

    let accordion_panels = document.querySelectorAll('.accordion .panel');
    accordion_panels.forEach((panel) => {
        let button = panel.querySelector('button.toggle');
        button.addEventListener('click', () => {
            panel.classList.toggle("active");
        });
    });

    let tab_selectors = document.querySelectorAll('.tab-selector');
    tab_selectors.forEach((tab_selector) => {
        let tab_links = tab_selector.querySelectorAll('.tab-link');
        tab_links.forEach((tab_link) => {
            tab_link.addEventListener('click', () => {
                if (!tab_link.classList.contains('active')) {
                    let index = tab_link.dataset.target;
                    let new_tab = tab_selector.querySelector('.tab-content[data-tab="' + index + '"]');
                    let active_tab = tab_selector.querySelector('.tab-link.active');
                    let active_tab_content = tab_selector.querySelector('.tab-content.active');
                    active_tab.classList.remove('active')
                    active_tab_content.classList.remove('active')
                    tab_link.classList.add("active");
                    new_tab.classList.add("active");
                }
            });
        });
    });
});